export const person = {
    name: ' Jalen ',
    jobinfo: ' Create and develop graphical user interfaces ',
    jobtitle: ' Front-end Developer ',
};

